import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import rpStyles from "../../_css/RoleplayManagement.module.css";

const PaginationUI = ({ currentPage, totalPages, onPageChange, hasData }) => {
  if (totalPages <= 1 || !hasData) {
    return null;
  }

  const handlePageChangeInternal = (newPage) => {
    if (typeof onPageChange === "function") {
      onPageChange(newPage);
    }
  };

  return (
    <div className={rpStyles.paginationContainer}>
      <div className={rpStyles.paginationWrapper}>
        <button
          disabled={currentPage === 1}
          onClick={() => handlePageChangeInternal(currentPage - 1)}
          className={rpStyles.paginationButton}
        >
          <ChevronLeft size={16} />
          Previous
        </button>

        <div className={rpStyles.paginationNumbers}>
          {[...Array(totalPages)].map((_, idx) => {
            const pageNum = idx + 1;
            const isActive = pageNum === currentPage;
            return (
              <button
                key={pageNum}
                onClick={() => handlePageChangeInternal(pageNum)}
                className={`${rpStyles.paginationNumber} ${
                  isActive ? rpStyles.paginationNumberActive : ""
                }`}
              >
                {pageNum.toString().padStart(2, "0")}
              </button>
            );
          })}
        </div>

        <button
          disabled={currentPage === totalPages}
          onClick={() => handlePageChangeInternal(currentPage + 1)}
          className={`${rpStyles.paginationButton} ${rpStyles.paginationButtonNext}`}
        >
          Next
          <ChevronRight size={16} />
        </button>
      </div>
    </div>
  );
};

export default PaginationUI;

